import _ from '@app/utils.js'

_.onElementReady('.areas-list-header', header => {
  const links = header.querySelectorAll('a')
  const tabs  = document.querySelectorAll('.areas-list-tab')

  function activate(targetId) {
    links.forEach(a => a.classList.toggle('active', a.getAttribute('href') === '#' + targetId))
    tabs.forEach(tab => tab.classList.toggle('active', tab.id === targetId))
  }

  links.forEach(a => {
    a.addEventListener('click', evt => {
      evt.preventDefault()
      const targetId = a.getAttribute('href').slice(1)
      activate(targetId)
      history.replaceState(null, '', '#' + targetId)
    })
  })

  // Attiva la tab iniziale: hash URL oppure prima tab.
  const initial = (window.location.hash.slice(1)) || (links[0]?.getAttribute('href').slice(1))
  if (initial) {
    activate(initial)
  }
})
